export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    AbstractListEmployeeAlerts: ['ListEmployeeAlertsByCountry', 'ListEmployeeAlertsByEmployee'],
    EmployeeAlertReason: [
      'EmployeeAlertAgeOutOfRange',
      'EmployeeAlertContractsNotContinuous',
      'EmployeeAlertContractsNotFound',
      'EmployeeAlertDuplicateCompanyContracts',
      'EmployeeAlertDuplicateJobHistories',
      'EmployeeAlertDuplicateMainContracts',
      'EmployeeAlertEmployeeNotInactiveButNoActiveContract',
      'EmployeeAlertEmployeeNotInactiveButNoActiveJobHistory',
      'EmployeeAlertEmptyDateOfBirth',
      'EmployeeAlertFirstContractStartDateNotSameAsHiredDate',
      'EmployeeAlertFirstJobHistoryStartDateNotSameAsHiredDate',
      'EmployeeAlertHiredDateBeforeAnyMindStarts',
      'EmployeeAlertInactiveManager',
      'EmployeeAlertInvalidEmployeeCode',
      'EmployeeAlertInvalidJapanesePhoneticName',
      'EmployeeAlertInvalidLegalFullName',
      'EmployeeAlertInvalidPreferredFullName',
      'EmployeeAlertJobHistoriesNotContinuous',
      'EmployeeAlertJobHistoriesNotFound',
      'EmployeeAlertLastContractEndDateNotSameAsLastJobHistoryEndDate',
      'EmployeeAlertLastContractEndDateNotSameAsResignationDate',
      'EmployeeAlertLastContractWillEnd',
      'EmployeeAlertLastJobHistoryEndDateNotSameAsResignationDate',
      'EmployeeAlertLastJobHistoryWillEnd',
      'EmployeeAlertLastWorkingDateBeforeAnyMindStarts',
      'EmployeeAlertLastWorkingDateBeforeHiredDate',
      'EmployeeAlertProbationFailedStillEmployed',
      'EmployeeAlertResignationDateBeforeAnyMindStarts',
      'EmployeeAlertResignationDateBeforeHiredDate',
      'EmployeeAlertResignationDateBeforeLastWorkingDate',
    ],
    EmployeeBankCommon: ['EmployeeBank', 'EmployeeConsultingFeeBank'],
    EmployeeExternalAccount: [
      'EmployeeExternalAccountEloomi',
      'EmployeeExternalAccountGitHub',
      'EmployeeExternalAccountGoogle',
      'EmployeeExternalAccountGreenhouse',
      'EmployeeExternalAccountHubSpot',
      'EmployeeExternalAccountSlack',
    ],
    EmployeeFile: ['EmployeeSignature'],
    EnumWithDisplayName: [
      'ContractTypeWithDisplayName',
      'EmployeeAlertReasonTypeWithDisplayName',
      'GoogleProductAndSKUWithDisplayName',
    ],
    EpmEmployeeAllocation: [
      'EpmEmployeeAllocationAllocationKey',
      'EpmEmployeeAllocationFunctionality',
      'EpmEmployeeAllocationRoleType',
      'EpmEmployeeAllocationVdd',
      'EpmEmployeeAllocationVdp',
    ],
    ExportHistory: [
      'EmployeeExportHistory',
      'ExternalAccountExportHistory',
      'NumberOfEmployeeExportHistory',
      'PerformanceReviewExportHistory',
      'ProbationReviewExportHistory',
    ],
    ExportImportProgress: [
      'EmployeeExportProgress',
      'EmployeeImportProgress',
      'ExternalAccountExportProgress',
      'ManagerialAccountingImportProgress',
      'NumberOfEmployeeExportProgress',
      'PerformanceReviewExportProgress',
      'ProbationReviewExportProgress',
    ],
    ImportHistory: ['EmployeeImportHistory', 'ManagerialAccountingImportHistory'],
    ImportHistoryError: ['EmployeeImportHistoryError', 'ManagerialAccountingImportHistoryError'],
    ListItem: [
      'BusinessUnit',
      'Company',
      'CompanyEmailDomain',
      'Country',
      'Currency',
      'Department',
      'Division',
      'Employee',
      'EmployeeExportHistory',
      'EmployeeExportProgress',
      'EmployeeExternalAccountEloomi',
      'EmployeeExternalAccountGitHub',
      'EmployeeExternalAccountGoogle',
      'EmployeeExternalAccountGreenhouse',
      'EmployeeExternalAccountHubSpot',
      'EmployeeExternalAccountSlack',
      'EmployeeImportHistory',
      'EmployeeImportProgress',
      'EmployeeListCustomFilter',
      'EpmMasterAllocationKey',
      'EpmMasterFunctionality',
      'EpmMasterRoleType',
      'EpmMasterVdd',
      'ExternalAccountExportHistory',
      'ExternalAccountExportProgress',
      'HubspotPipeline',
      'Job',
      'ListEmployeeAlertItemByCountry',
      'ListEmployeeAlertItemByEmployee',
      'Location',
      'ManagerChangeReservation',
      'ManagerialAccountingImportHistory',
      'ManagerialAccountingImportProgress',
      'McpConnection',
      'NumberOfEmployeeExportHistory',
      'NumberOfEmployeeExportProgress',
      'PerformanceReview',
      'PerformanceReviewExportHistory',
      'PerformanceReviewExportProgress',
      'PerformanceReviewResult',
      'ProbationReview',
      'ProbationReviewAuditLog',
      'ProbationReviewExportHistory',
      'ProbationReviewExportProgress',
      'ReasonForLeaving',
    ],
    MyDevelopmentPlan: ['PerformanceReviewMyDevelopmentPlanV1', 'PerformanceReviewMyDevelopmentPlanV2'],
    NotificationOption: ['NotificationOptionCustomDates', 'NotificationOptionStaticDates'],
    PerformanceReviewTarget: [
      'PerformanceReviewTargetMultipleMissions',
      'PerformanceReviewTargetNumericMonthly',
      'PerformanceReviewTargetNumericSales',
      'PerformanceReviewTargetNumericTotal',
    ],
    PerformanceReviewTargetNumericTarget: [
      'PerformanceReviewTargetNumericMonthlyTarget',
      'PerformanceReviewTargetNumericSalesItemTarget',
    ],
    QuickAccessSearchResult: [
      'QuickAccessSearchResultEmployee',
      'QuickAccessSearchResultPage',
      'QuickAccessSearchResultPerformanceReview',
      'QuickAccessSearchResultProbationReview',
    ],
    ReportNumberOfEmployee: [
      'ReportNumberOfEmployeeByBusinessUnit',
      'ReportNumberOfEmployeeByCompany',
      'ReportNumberOfEmployeeByCompanyBusinessUnitDepartment',
      'ReportNumberOfEmployeeByCompanyBusinessUnitJob',
      'ReportNumberOfEmployeeByJob',
      'ReportNumberOfEmployeeByLocation',
      'ReportNumberOfEmployeeByNationality',
    ],
    ReportNumberOfEmployeeByKey: ['ReportNumberOfEmployeeAll', 'ReportNumberOfEmployeeTurnover'],
    ReportNumberOfEmployeeByYearHalf: [
      'NumberOfEmployeeByAllocationKey',
      'NumberOfEmployeeByFunctionality',
      'NumberOfEmployeeByRoleType',
      'NumberOfEmployeeByVdd',
      'NumberOfEmployeeByVdp',
      'NumberOfEmployeeByVdpVddComposite',
    ],
    ReportNumberOfEmployeeItem: [
      'ReportNumberOfEmployeeByBusinessUnitItem',
      'ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentItemBusinessUnit',
      'ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentItemCompany',
      'ReportNumberOfEmployeeByCompanyBusinessUnitDepartmentItemDepartment',
      'ReportNumberOfEmployeeByCompanyBusinessUnitJobItemBusinessUnit',
      'ReportNumberOfEmployeeByCompanyBusinessUnitJobItemCompany',
      'ReportNumberOfEmployeeByCompanyBusinessUnitJobItemJob',
      'ReportNumberOfEmployeeByCompanyItem',
      'ReportNumberOfEmployeeByJobItem',
      'ReportNumberOfEmployeeByLocationItemCountry',
      'ReportNumberOfEmployeeByLocationItemLocation',
      'ReportNumberOfEmployeeByNationalityItemCompany',
      'ReportNumberOfEmployeeByNationalityItemCountry',
      'ReportNumberOfEmployeeByNationalityItemNationality',
    ],
    ReportNumberOfEmployeeItemByYearHalf: [
      'NumberOfEmployeeByAllocationKeyItem',
      'NumberOfEmployeeByFunctionalityItem',
      'NumberOfEmployeeByRoleTypeItem',
      'NumberOfEmployeeByVddItem',
      'NumberOfEmployeeByVdpItem',
      'NumberOfEmployeeByVdpVddCompositeItemVdd',
      'NumberOfEmployeeByVdpVddCompositeItemVdp',
    ],
    SignInCallback: ['SignInCallbackError', 'SignInCallbackSuccess'],
  },
};
export default result;
